export const TRACK_SESSION_TOKEN_COOKIE_KEY_NAME = "_trstkn";
export const TRACK_EVENT_COOKIE_KEY_NAME = "_evnt";

export const API_TRACK_SESSION_TOKEN_ENDPOINT = "/track/session/token";